export interface SmsEligibleStatusOption {
  value: string;
  label: string;
}

export const SMS_ELIGIBLE_LEAD_STATUSES: SmsEligibleStatusOption[] = [
  { value: 'new', label: 'New' },
  { value: 'no_answer', label: 'No Answer' },
  { value: 'unreachable', label: 'Unreachable' },
  { value: 'follow_up', label: 'Follow Up' },
  { value: 'busy', label: 'Busy' },
  { value: 'gatekeeper', label: 'Gatekeeper' },
  { value: 'operator', label: 'Operator' },
  { value: 'app_in', label: 'App In' },
  { value: 'app_out', label: 'App Out' },
  { value: 'submitted', label: 'Submitted' },
  { value: 'contract', label: 'Contract' },
  { value: 'funded', label: 'Funded' },
  { value: 'interested', label: 'Interested' },
  { value: 'not_interested', label: 'Not Interested' },
  { value: 'unqualified', label: 'Unqualified' },
  { value: 'out_of_business', label: 'Out of Business' },
  { value: 'wrong_number', label: 'Wrong Number' },
  { value: 'deceased', label: 'Deceased' },
  { value: 'spanish', label: 'Spanish' },
];

export function formatSmsEligibleStatusLabel(status: string): string {
  const found = SMS_ELIGIBLE_LEAD_STATUSES.find((s) => s.value === status);
  return found?.label ?? status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
